import styled from 'styled-components';

export const TopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #00000080;
  height: 60px;
  padding: 10px 10px 10px 20px;
  box-shadow: inset 0 -1px 0 0 #ffffff1f;
  backdrop-filter: blur(15px);
`;

export const TopSectionActions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Title = styled.h2`
  font-family: 'Heebo', sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
  font-style: normal;
`;

export const ScrollWrapper = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: none;
  &:hover {
    border-color: #ffffff66;
  }
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0.1);
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 4px;
    height: 60px;
    width: 6px;
    border-right-style: inset;
    border-right-width: calc(100vw + 100vh);
    border-color: inherit;
  }
  @media (min-width: 481px) {
    border-color: rgba(0, 0, 0, 0);
  }
  @media (max-width: 480px) {
    border-color: #ffffff66;
  }
`;

export const ContentSection = styled.div`
  background: #000000a6;
  padding: 12px 20px;

  border-bottom: 1px solid #ffffff1f;
  width: 100%;
  backdrop-filter: blur(15px);
`;

export const Description = styled.div`
  overflow: hidden;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  white-space: pre-wrap;
  em {
    font-style: italic;
  }
  s {
    text-decoration: line-through;
  }
`;

export const TooltipButton = styled.button`
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  transition-duration: 0.5s;
  &:hover {
    background: #ffffff1a;
  }
  &:focus {
    background: #ffffff33;
  }
`;

export const Container = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  font-family: 'Heebo', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  border: 1px solid #ffffff1f;
  border-radius: 16px;
  overflow: hidden;
`;

export const ImageBg = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #171a1c;
  border-radius: 8px;
`;
